'use strict';

export {};

declare global {
    interface String {
        indent : ( level? : number ) => string;
        asLogLine : ( lineLength? : number, lineChar?: string ) => string;
    }

    interface StringConstructor {
        getHash : () => string;
    }
}

const indentSpaceCount = 4;

String.prototype.indent = function( level = 1 ) {
    return ' '.repeat( level * indentSpaceCount ) + this;
};

String.prototype.asLogLine = function( lineLength : number = global.logSeparatorWidth, lineChar : string = '-' ) {
    const logText             = this.length ? ` ${this} ` : '',
          remainingLineLength = Math.max( lineLength - logText.length, 0 ),
          preLength           = Math.floor( remainingLineLength / 2 ),
          postLength          = remainingLineLength - preLength;

    return lineChar.repeat( preLength ) + logText + lineChar.repeat( postLength );
};

String.getHash = function() {
    let retVal = '',
        n      = ( 1000 + Math.floor( Math.random() * 8999 ) ) + new Date().getTime() * 1000000;

    const codeset = '0123456789abcdefghijkmnopqrstuvwxyzABCDEFGHIJKLMNPQRSTUVWXYZ',
          base    = codeset.length;

    while ( n > 0 ) {
        retVal = codeset.substr( n % base, 1 ) + retVal;
        n = Math.round( n / base );
    }

    return retVal;
};
